import { render, staticRenderFns } from "./oatManagement.vue?vue&type=template&id=5f8dd8a6&scoped=true"
import script from "./oatManagement.vue?vue&type=script&lang=js"
export * from "./oatManagement.vue?vue&type=script&lang=js"
import style0 from "./oatManagement.vue?vue&type=style&index=0&id=5f8dd8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8dd8a6",
  null
  
)

export default component.exports